import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "notification-icon" }

import { onMounted, computed } from 'vue';
import { Bell } from '@element-plus/icons-vue';
import { useNotificationStore } from '@/store/notification';
import { useRouter } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'NotificationIcon',
  setup(__props) {

const router = useRouter();
const store = useNotificationStore();
const unreadCount = computed(() => store.unreadCount);

const navigateToNotifications = () => {
  router.push('/notifications');
};

onMounted(() => {
  // 初始化时获取未读消息数量
  store.fetchNotifications('unread');
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_badge = _resolveComponent("el-badge")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_badge, {
      value: unreadCount.value,
      hidden: unreadCount.value === 0,
      class: "notification-badge"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_button, {
          class: "notification-btn",
          icon: _unref(Bell),
          circle: "",
          onClick: navigateToNotifications
        }, null, 8, ["icon"])
      ]),
      _: 1
    }, 8, ["value", "hidden"])
  ]))
}
}

})